import React, { useContext, useEffect, useState } from 'react'
import EditCtrl from '../cmp/EditCtrl.js';
import {qr_encode} from '../qr.js'
import {dataContext,localestr} from '../utils.js'
import icon from '../icons.svg'

function roundedRect(ctx, x, y, width, height, radius,t_l=1,t_r=1,b_l=1,b_r=1) {
    ctx.beginPath();
    ctx.moveTo(x + radius*t_l, y);
    if(!t_l) ctx.lineTo(x,y+radius);
    else ctx.arcTo(x, y, x, y + radius, radius);
    ctx.lineTo(x,y+height-radius);
    if(!b_l) ctx.lineTo(x,y + height);
    else ctx.arcTo(x, y + height, x + radius*b_l, y + height, radius);
    ctx.lineTo(x+width-radius*b_r,y+height);
    ctx.arcTo(x+width, y+height, x+width, y+height-radius, radius);
    ctx.lineTo(x+width,y+radius);
    if(!t_r) ctx.lineTo(x+width,y);
    else ctx.arcTo(x+width, y, x+width-radius*t_r, y, radius);
    ctx.fill();
}	  
	  
function rhombus(ctx, x, y, width, height) {
    ctx.beginPath();
    ctx.moveTo(x+width/2, y);
    ctx.lineTo(x+width,y+height/2);
    ctx.lineTo(x+width/2,y+height);
    ctx.lineTo(x,y+height/2);
    ctx.fill();
}	  
	
function horizontalText(ctx,str, x, y, width, height) {
    ctx.font = height+"px arial";
    let text = ctx.measureText(str);
    let tx=x;
    if(text.width<width) tx+=(width-text.width)/2;
    ctx.fillText(str, tx, y+height*0.9,width);
}
	
function verticalText(ctx,str, x, y, width, height, dir=-1) {
    ctx.save();
    if(dir<0) ctx.translate(x+width*0.75, y+height);
    else ctx.translate(x, y);
    ctx.rotate(dir*Math.PI/2);
    ctx.font = width+"px arial";
    let text = ctx.measureText(str);
    let tx=0;
    if(text.width<height) tx=(height-text.width)/2;
    ctx.fillText(str, tx, 0,height);
    ctx.restore();
}

export function createQR(str, logoText, options) {
    const {
        color2 = '#000000',
        qr_stl = 4,
        text1 = '',
        text2 = '',
        text3 = '',
        text4 = '',
        text5 = '',
        color1 = '#000000',
        logoImage = null
    } = options;
    
    if(!str || !str.length) return null;
    const canvas = document.createElement('canvas');
    if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        const mtx = qr_encode(str);
        const size = mtx.length;
        canvas.width = size * 10;
        canvas.height = size * 10;
        ctx.fillStyle = color2;
  
        const stl = parseInt(qr_stl);
        const size_logo = size * 3;
              
        if(logoText || (logoImage && logoImage.src)){
            for(let y = parseInt(size*0.2); y < size*0.8; y++){
                for(let x = parseInt(size*0.2); x < size*0.8; x++){
                    if((x*10 - size*5)*(x*10 - size*5) + (y*10 - size*5)*(y*10 - size*5) < size_logo*size_logo/4) {
                        mtx[y][x] = 0;
                    }
                }
            }
        }
              
        for(let y = 0; y < size; y++){
            for(let x = 0; x < size; x++){
                let val = mtx[y][x];
                if(stl === 1){
                    const m = (y<8&&x<8)||(size-y<8&&x<8)||(y<8&&size-x<8); //Угли
                    const m1 = (y===0&&x===0)||(size-y===7&&x===0)||(y===0&&size-x===7); //Угли
                    const m2 = (y===0&&x===6)||(size-y===7&&x===6)||(y===0&&size-x===1); //Угли
                    const m3 = (y===6&&x===0)||(size-y===1&&x===0)||(y===6&&size-x===7); //Угли
                    const m4 = (y===6&&x===6)||(size-y===1&&x===6)||(y===6&&size-x===1); //Угли
                    const n1 = (y===2&&x===2)||(size-y===5&&x===2)||(y===2&&size-x===5); //Угли
                    const n2 = (y===2&&x===4)||(size-y===5&&x===4)||(y===2&&size-x===3); //Угли
                    const n3 = (y===4&&x===2)||(size-y===3&&x===2)||(y===4&&size-x===5); //Угли
                    const n4 = (y===4&&x===4)||(size-y===3&&x===4)||(y===4&&size-x===3); //Угли
                    if(m1) roundedRect(ctx,10*x, 10*y, 10, 10, 5,1,0,0,0);
                    else if(m2) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,1,0,0);
                    else if(m3) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,1,0);
                    else if(m4) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,0,1);
                    else if(n1) roundedRect(ctx,10*x, 10*y, 10, 10, 5,1,0,0,0);
                    else if(n2) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,1,0,0);
                    else if(n3) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,1,0);
                    else if(n4) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,0,1);
                    else if(m&&val) ctx.fillRect(10*x, 10*y, 10, 10);
                    else if(val) roundedRect(ctx,10*x, 10*y, 10, 10,4);
                } else if(stl === 2){
                    let t_l=1;
                    let t_r=1;
                    let b_l=1;
                    let b_r=1;
                    if(y&&mtx[y-1][x]){
                        t_l=0;
                        t_r=0;
                    }
                    if(y&&x&&mtx[y-1][x-1]) t_l=-1;
                    if(y&&x+1<size&&mtx[y-1][x+1]) t_r=-1;
                    if(y+1<size&&mtx[y+1][x]){
                        b_l=0;
                        b_r=0;
                    }
                    if(y+1<size&&x&&mtx[y+1][x-1]) b_l=-1;
                    if(y+1<size&&x+1<size&&mtx[y+1][x+1]) b_r=-1;
                    if(x&&mtx[y][x-1]){
                        if(t_l===1) t_l=0;
                        if(b_l===1) b_l=0;
                    }
                    if(x+1<size&&mtx[y][x+1]){
                        if(t_r===1) t_r=0;
                        if(b_r===1) b_r=0;
                    }
                    if(val) roundedRect(ctx,10*x, 10*y, 10, 10,5,t_l,t_r,b_l,b_r);
                } else if(stl === 3){
                    const m = (y<8&&x<8)||(size-y<8&&x<8)||(y<8&&size-x<8); //Угли
                    const m1 = (y===0&&x===0)||(size-y===7&&x===0)||(y===0&&size-x===7); //Угли
                    const m2 = (y===0&&x===6)||(size-y===7&&x===6)||(y===0&&size-x===1); //Угли
                    const m3 = (y===6&&x===0)||(size-y===1&&x===0)||(y===6&&size-x===7); //Угли
                    const m4 = (y===6&&x===6)||(size-y===1&&x===6)||(y===6&&size-x===1); //Угли
                    const n1 = (y===2&&x===2)||(size-y===5&&x===2)||(y===2&&size-x===5); //Угли
                    const n2 = (y===2&&x===4)||(size-y===5&&x===4)||(y===2&&size-x===3); //Угли
                    const n3 = (y===4&&x===2)||(size-y===3&&x===2)||(y===4&&size-x===5); //Угли
                    const n4 = (y===4&&x===4)||(size-y===3&&x===4)||(y===4&&size-x===3); //Угли
                    if(m1) roundedRect(ctx,10*x, 10*y, 10, 10, 5,1,0,0,0);
                    else if(m2) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,1,0,0);
                    else if(m3) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,1,0);
                    else if(m4) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,0,1);
                    else if(n1) roundedRect(ctx,10*x, 10*y, 10, 10, 5,1,0,0,0);
                    else if(n2) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,1,0,0);
                    else if(n3) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,1,0);
                    else if(n4) roundedRect(ctx,10*x, 10*y, 10, 10, 5,0,0,0,1);
                    else if(m&&val) ctx.fillRect(10*x, 10*y, 10, 10);
                    else if(val) roundedRect(ctx,10*x+2, 10*y+2, 6, 6,3);
                } else if(stl === 4){
                    const m = (y<8&&x<8)||(size-y<8&&x<8)||(y<8&&size-x<8); //Угли
                    if(m&&val) ctx.fillRect(10*x, 10*y, 10, 10);
                    else if(val) rhombus(ctx,10*x, 10*y, 10, 10);
                    
                } else {
                    if(val) ctx.fillRect(10*x, 10*y, 10, 10);
                }
            }
        }
        
        if(logoText) {
            horizontalText(ctx, logoText, size*5 - size_logo*0.4 + 5, size*5 - size_logo*0.3 + 2, size_logo*0.8, size_logo*0.6);
        } 
        else if(logoImage && logoImage.complete) {
            ctx.drawImage(logoImage, size*5 - size_logo*0.45 + 5, size*5 - size_logo*0.45 + 5, size_logo*0.9, size_logo*0.9);
        }
            
        const inMemCanvas = document.createElement('canvas');
        const inMemCtx = inMemCanvas.getContext('2d');
        inMemCanvas.width = 400;
        inMemCanvas.height = 400;
        inMemCtx.drawImage(canvas, 0, 0, 400, 400);
        canvas.width = 600;
        canvas.height = 600;
        ctx.drawImage(inMemCanvas, 100, 100);
        ctx.fillStyle = color1;
        verticalText(ctx, text1, 0, 100, 70, 400);
        horizontalText(ctx, text2, 0, 0, 600, 70);
        verticalText(ctx, text3, 530, 100, 70, 400, 1);
        horizontalText(ctx, text4, 0, 520, 600, 40);
        horizontalText(ctx, text5, 0, 560, 600, 40);

        return canvas.toDataURL();
    }
    return null;
}

// Основной компонент
export default function ServQRDesign({data=undefined,actions}){
    const context=useContext(dataContext)
    const getData=context.getData
    const catTables=context.data['catTables']
    const sysConst=context.data['sysConst']

    const [qr_type, setQR] = useState(1);
    const [text1, setText1] = useState(localestr('Скануй'));
    const [text2, setText2] = useState(localestr('Замовляй'));
    const [text3, setText3] = useState(localestr('Оплачуй'));
    const [text4, setText4] = useState(sysConst.sysFirm||null);
    const [text5, setText5] = useState(localestr(''));
    const [color1, setColor1] = useState({name: 'color', src: '#000000'});
    const [color2, setColor2] = useState({name: 'color', src: '#000000'});
    const [hall, setHall] = useState(null);
    const [qr_stl, setStl] = useState(4);
    // eslint-disable-next-line
    const [logoImg, setLogo] = useState(new Image());
    const [logoLoaded, setLogoLoaded] = useState(false);

    useEffect(() => {
        if (typeof catTables === 'undefined') getData('catTables');
        logoImg.onload = () => setLogoLoaded(true);
        logoImg.src = sysConst.logo;
        return () => {
            logoImg.onload = null;
        };
    }, [catTables, getData, logoImg, sysConst.logo]);

    let cont = null;
    if(qr_type === 2) {
        cont = <EditCtrl Capt={localestr('Зал')} Value={hall} typeVal={'catHalls'} setVal={(d)=>{setHall(d)}} width1='95' width2='242'/>;
    }
	
    let qr_data = [];
    let qr = null;
    
    if(qr_type === 2){
        if(hall){
            const tbls = catTables.filter(el => el.owner.id === hall.id);
            tbls.sort((a,b) => a.name - b.name);
            qr_data = tbls.map(el => ({
                name: hall.name.substring(0,3) + el.name,
                data: createQR(
                    sysConst.url + 'gst?tb=' + el.id, 
                    el.name, 
                    {
                        color2: color2.src,
                        qr_stl,
                        text1,
                        text2,
                        text3,
                        text4,
                        text5,
                        color1: color1.src
                    }
                )
            }));
        }
    } else {
        qr_data.push({
            name: 'online',
            data: createQR(
                sysConst.url + 'menu', 
                null, 
                {
                    color2: color2.src,
                    qr_stl,
                    text1,
                    text2,
                    text3,
                    text4,
                    text5,
                    color1: color1.src,
                    logoImage: logoLoaded ? logoImg : null
                }
            )
        });
    }
    
    qr = qr_data.map((el, idx) => 
        <img key={idx} style={{width:'60mm', margin:'10px'}} src={el.data} alt='' />
    );

    const downloadClick = async () => {
        if (!qr_data || !qr_data.length) return;
        for (const el of qr_data) {
            const a = document.createElement("a")
            a.style.display = "none"
            a.href = el.data
            a.download = el.name+'.png'
            document.body.appendChild(a)
            a.click()
            await new Promise(resolve => setTimeout(resolve, 300));
            a.remove()
        }
    }

    return(
        <>
        <div className='no-print' style={{display:'flex',flexDirection:'column', margin:'3px'}}>
            <div style={{margin:'2px 0',display:'inherit'}}>{localestr('Наліпки для ')}</div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <label><input type='radio' value={1} checked={qr_type===1} onChange={(e)=>{setQR(1)}} /> {localestr('замовлення на доставку')} </label>
                <label><input type='radio' value={2} checked={qr_type===2} onChange={(e)=>{setQR(2)}} /> {localestr('столів')} </label>
            </div>
            <EditCtrl Capt={localestr('Текст зліва')} Value={text1} typeVal={'text'} setVal={(d)=>{setText1(d)}} width1='95' width2='242'/>
            <EditCtrl Capt={localestr('Текст зверху')} Value={text2} typeVal={'text'} setVal={(d)=>{setText2(d)}} width1='95' width2='242'/>
            <EditCtrl Capt={localestr('Текст зправа')} Value={text3} typeVal={'text'} setVal={(d)=>{setText3(d)}} width1='95' width2='242'/>
            <EditCtrl Capt={localestr('Текст знизу 1')} Value={text4} typeVal={'text'} setVal={(d)=>{setText4(d)}} width1='100' width2='237'/>
            <EditCtrl Capt={localestr('Текст знизу 2')} Value={text5} typeVal={'text'} setVal={(d)=>{setText5(d)}} width1='100' width2='237'/>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Колір тексту')} Value={color1} typeVal={'color'} setVal={(d)=>{setColor1(d)}} width1='91' width2='66'/>
                <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Колір QR коду')} Value={color2} typeVal={'color'} setVal={(d)=>{setColor2(d)}} width1='107' width2='66'/>
            </div>
            <EditCtrl Capt={localestr('Стиль QR коду')} Value={qr_stl} typeVal={'selStyleQR'} setVal={(d)=>{setStl(d)}} width1='115' width2='222'/>
            {cont}
        </div>
        <div  className='imgContainer' style={{display:'flex',flexDirection:'column', margin:'3px',maxWidth:'674px',position:'relative',alignItems:'center'}}>
            <div className='imgButton no-print' onClick={e=>{e.preventDefault();window.print()}} title={localestr('Друкувати')} style={{top:'10px',right:'28px'}}><img src={icon+'#b503'} alt={localestr('Друкувати')} /></div>
            <div className='imgButton no-print' onClick={e=>{e.preventDefault();downloadClick()}} title={localestr('Зберегти')} style={{top:'10px'}}><img src={icon+'#b951'} alt={localestr('Зберегти')} /></div>
            {qr}
        </div>
        </>
    )
}